import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { gotoNewPage } from '@src/utils';
import { RuleUrl } from '@src/constants';

const Layout = ({ content }) => {

    return (
        <div className={styles.layout} onClick={gotoNewPage({ url: RuleUrl, type: 'web' })}>
            活动规则
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
